import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { CollapsibleDirective } from '../../directives/collapsibleDirective.directive';
import { MenuCollapseItemComponent } from '../menu-collapse-item/menu-collapse-item.component';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import { PageContainerService } from '../../services/page-container.service';

@Component({
  selector: 'z-side-menu',
  standalone: true,
  imports: [CommonModule, MenuCollapseItemComponent, CollapsibleDirective],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  logoUrl = input.required<string>();
  menuMaxWidth = signal<number>(0);
  activeChild!: NavigationItem;

  navigationItem$ = this.pageContainerService.activeSectionRoute.pipe(
    tap(nav => {
      if (nav?.children?.length) {
        this.setActiveItem(nav);

        this.menuMaxWidth.set(260);
      } else this.menuMaxWidth.set(0);
    }),
  );

  menuExpanded$: Observable<boolean> = this.pageContainerService.menuExpanded;

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {}

  setActiveItem(nav: NavigationItem | null) {
    if (!nav) {
      return;
    }
    const currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url)?.routePath;

    const index = nav.children.findIndex(
      y => y && currentPath && y.id === currentPath[1],
    );
    if (index !== -1) {
      this.activeChild = nav.children[index];
    } else {
      return;
    }
  }
}
